var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2438_25107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0157 25.1986C15.159 25.1986 16.3023 25.1986 17.4379 25.1986C18.9701 25.1829 20.3312 24.1013 20.6579 22.5964C20.8757 21.601 20.829 20.5821 20.6579 19.5867C20.2612 17.2275 18.2001 15.2681 15.8435 15.0486C14.8323 14.9546 13.8057 14.9859 12.7946 14.9937C10.3446 15.0173 8.16678 16.7259 7.49012 19.1008C7.24901 19.9629 7.28012 20.8329 7.28012 21.7108C7.28012 23.6937 8.76567 25.1986 10.7257 25.1986H14.0157Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53564 9.31916C9.53564 11.8194 11.5423 13.8494 14.0234 13.8573C16.5045 13.8573 18.519 11.8194 18.519 9.30349C18.519 6.78754 16.5045 4.76538 14.0079 4.77322C11.5345 4.77322 9.53564 6.81105 9.53564 9.31916Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01678 20.6213C5.12567 17.7605 6.35456 15.5267 8.719 13.9121C8.14344 13.2537 7.45122 12.8148 6.60344 12.7521C5.639 12.6815 4.67456 12.6659 3.71011 12.7207C2.02233 12.8305 0.754556 14.0218 0.575667 15.7148C0.474556 16.6788 0.497889 17.6664 0.575667 18.6383C0.645667 19.6651 1.46233 20.5194 2.42678 20.5978C3.28233 20.6683 4.13789 20.6134 5.03233 20.6134L5.01678 20.6213Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4001 8.17484C8.4001 6.29376 6.89899 4.77322 5.0401 4.76538C3.17343 4.76538 1.64899 6.3016 1.65677 8.18268C1.65677 10.0559 3.18121 11.5765 5.03232 11.5765C6.88343 11.5765 8.39232 10.0559 8.39232 8.17484H8.4001Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6545 8.16701C19.6545 10.0481 21.1557 11.5686 23.0145 11.5765C24.8657 11.5765 26.3823 10.0638 26.3979 8.19052C26.4134 6.31728 24.8812 4.76539 23.0223 4.77322C21.1634 4.77322 19.6623 6.29376 19.6623 8.17484L19.6545 8.16701Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0157 25.1986H10.7257C8.76567 25.1986 7.2879 23.6937 7.28012 21.7108C7.28012 20.8329 7.24901 19.9551 7.49012 19.1008C8.15901 16.7259 10.3446 15.0173 12.7946 14.9937C13.8135 14.9859 14.8323 14.9546 15.8435 15.0486C18.2001 15.2602 20.2612 17.2197 20.6579 19.5867C20.829 20.59 20.8757 21.601 20.6579 22.5964C20.3312 24.1091 18.9701 25.1829 17.4379 25.1986C16.2946 25.1986 15.159 25.1986 14.0157 25.1986Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.53564 9.31914C9.53564 6.81103 11.5268 4.78103 14.0079 4.77319C16.5045 4.77319 18.519 6.78752 18.519 9.30346C18.519 11.8194 16.5045 13.8572 14.0234 13.8572C11.5423 13.8572 9.54342 11.8194 9.53564 9.31914Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01676 20.6215C4.13009 20.6215 3.26676 20.6763 2.41121 20.6058C1.44676 20.5274 0.637872 19.6731 0.560095 18.6463C0.490095 17.6744 0.466761 16.6869 0.560095 15.7228C0.738983 14.022 2.00676 12.8306 3.69454 12.7288C4.65121 12.666 5.62343 12.6896 6.58787 12.7601C7.43565 12.8228 8.12787 13.2539 8.70343 13.9201C6.33898 15.5269 5.10232 17.7685 5.00121 20.6293L5.01676 20.6215Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40011 8.17484C8.40011 10.0559 6.89122 11.5765 5.04011 11.5765C3.189 11.5765 1.67233 10.0481 1.66455 8.18268C1.66455 6.3016 3.18122 4.76538 5.04788 4.76538C6.91455 4.76538 8.40788 6.29376 8.40788 8.17484H8.40011Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.069 20.6215C23.9557 20.6215 24.819 20.6763 25.6745 20.6058C26.639 20.5274 27.4479 19.6731 27.5257 18.6463C27.5957 17.6744 27.619 16.6869 27.5257 15.7228C27.3468 14.022 26.079 12.8306 24.3912 12.7288C23.4345 12.666 22.4623 12.6896 21.4979 12.7601C20.6501 12.8228 19.9579 13.2539 19.3823 13.9201C21.7468 15.5269 22.9834 17.7685 23.0845 20.6293H23.0768L23.069 20.6215Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6154 8.17484C19.6154 10.0559 21.1243 11.5765 22.9754 11.5765C24.8266 11.5765 26.3432 10.0481 26.351 8.18268C26.351 6.3016 24.8343 4.76538 22.9677 4.76538C21.101 4.76538 19.6077 6.29376 19.6077 8.17484H19.6154Z",
    stroke: "#4F84F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2438_25107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.9166b45d9e33ee3bf4ccc2878b4e8766.svg";
export { ForwardRef as ReactComponent };